module.exports = __webpack_public_path__ + "static/media/002.c74caa92.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/thumbs/002.jpg
// module id = 509
// module chunks = 0